import React, {useState, useRef, useEffect, useMemo} from 'react';
import './CreditCardField.css';
import { useField } from 'formik';
import validateRequired from "../utils/validateRequired";

const ExpirationDateInput = (props) => {
    const yearInputRef = useRef(null);

    const { label, name, isRequired, validation } = props;
    const [field, meta, helpers] = useField({
        name,
        validate: isRequired && !validation ? validateRequired : validation});
    const [value, setValue] = useState(() => {
        if (field.value) {
            const [month, year] = field.value.split('/');
            return { month, year: year.slice(-2) };
        }
        return { month: '', year: '' };
    });
    const { setValue: setFieldValue } = helpers;
    const [showSeparator, setShowSeparator] = useState(true);
    const hasError = useMemo(() => meta.error && meta.touched, [meta.error, meta.touched]);
    const errorMessageText = hasError ? meta.error : null;

    useEffect(() => {
        if (value.month.length === 2 && value.year.length === 2) {
            const fullYear = `20${value.year}`;
            setFieldValue(`${value.month}/${fullYear}`);
        } else if (value.month === '' || value.year === '') {
            setFieldValue('');
        }
    }, [value.month, value.year]);

    const resetField = (fieldOption) => {
        switch (fieldOption) {
            case 'month':
                setValue(prev => ({ ...prev, month: '' }));
                break;
            case 'year':
                setValue(prev => ({ ...prev, year: '' }));
                break;
            case 'both':
                setValue({ month: '', year: '' });
                break;
            default:
                break;
        }
        setFieldValue('');
    };

    const handleMonthChange = (e) => {
        let newValue = e.target.value;

        // Validación: no permitir "0" o "00"
        if (newValue === '0' || newValue === '00') {
            resetField('month');
            setShowSeparator(false);
            return;
        }

        // Validación: agregar "0" a los valores de 2 a 9
        if (newValue.length === 1 && newValue !== '1') {
            newValue = '0' + newValue;
        }

        // Validación: solo permitir valores entre 01 y 12
        if (parseInt(newValue, 10) > 12) {
            resetField('month');
            setShowSeparator(false);
            return;
        }

        if (newValue.length <= 2) {
            setValue(prev => ({ ...prev, month: newValue }));
            setShowSeparator(true);
            if (newValue.length === 2) {
                yearInputRef.current.focus();
            }
        }
    };

    const handleYearChange = (e) => {
        const newValue = e.target.value;
        if (newValue.length <= 2) {
            setValue(prev => ({ ...prev, year: newValue }));
        }
    };

    return (
        <div className="mantine-1ejqehl mantine__field__wrapper">
            <label className="mantine-b11773 mantine__field__label">
                {label}
                {isRequired && <span
                    className="mantine-103svbs mantine__field__required--error mantine-InputWrapper-required mantine-Select-required"
                    aria-hidden="true"> *</span>}
            </label>
            <div
                className={`${meta.error && meta.touched ? 'mantine__field__field--error' : 'mantine__field__field'}  mantine-rb5cy8 mantine__field__wrapper CCF__inputContainer`}>
                <input
                    className="mantine__field__field CCF__field CCF__fieldText"
                    type="text"
                    value={value.month}
                    onChange={handleMonthChange}
                    maxLength="2"
                    pattern="\d{1,2}"
                    placeholder="MM"
                    autoComplete="off"
                />
                {showSeparator && <span className="CCF__fieldText">/</span>}
                <input
                    className="mantine__field__field CCF__field CCF__fieldText"
                    type="text"
                    value={value.year}
                    onChange={handleYearChange}
                    maxLength="2"
                    pattern="\d{2}"
                    placeholder="YY"
                    ref={yearInputRef}
                    autoComplete="off"
                />
            </div>
            {errorMessageText && <p className="mantine-p951vp">{errorMessageText}</p>}
        </div>
    );
};

export default ExpirationDateInput;
